export const defaultControls = [
    "bold",
    "italic",
    "underline",
    "undo",
    "redo",
    "link",
    "alignLeft",
    "alignCenter",
    "alignRight",
    "indent",
    "outdent",
    "image",
    "unorderedList",
    "orderedList",
    "color",
    "fontFamily",
    "fontSize",
    "typeStyle",
    "clearFormatting"
];
export const defaults = {
    controls: defaultControls
};
